<template>
  <div v-if="data" class="space-y-12 content">
    <div v-if="!isRealtruckBrand(data.brand?.name)" class="text-xs pt-8">
      Disclaimer: The following information is provided by the manufacturer of the product and RealTruck is not
      responsible or liable for the content or accuracy of the information provided by the manufacturer.
    </div>

    <ProductExtraInfoDescription :data="data" />

    <template v-if="data.specifications || data.howItWorks || data.additionalFeatures || data.faq">
      <ProductExtraInfoDetails id="scrollTarget-details" :data="data" />
    </template>

    <template v-if="data.videos?.videos">
      <h2 id="scrollTarget-videos">Videos</h2>
      <ProductExtraInfoVideoList :videos="data.videos.videos" section="videos" :grid-cols="gridCols" />
    </template>

    <ProductExtraInfoInstallation v-if="data.installation" id="scrollTarget-install" :data="data" />

    <ProductExtraInfoWarranty v-if="data.warranty" id="scrollTarget-warranty" :data="data" />

    <div class="space-y-6 md:space-y-12">
      <ConstructorioABTest class="max-w-6xl m-auto">
        <template #original>
          <!-- RELATED/RECOMMENDED PRODUCTS -->
          <CarouselProduct
            v-if="hasRelatedProducts && $sitewideConfig.config.recommendedProductsEnabled"
            product-type="related"
          />
          <CarouselProduct v-else-if="$sitewideConfig.config.recommendedProductsEnabled" product-type="recommended" />
        </template>

        <template #constructor>
          <ConstructorioRecommendations pod-id="product-page-1" :item-id="data.productLineSlug" />
        </template>
      </ConstructorioABTest>
      <SimpleAccordion
        v-if="yotpoEnabled && hasCustomerPhotos && !!$sitewideConfig.config.yotpoProductGalleryId"
        id="scrollTarget-photos"
        header="Customer Photos"
      >
        <h2 v-if="!$device.isMobile">Customer Photos</h2>
        <KetchWrapper name="Customer Photos" class="bg-gray-lighter">
          <YotpoCustomerPhotos :yotpo-id="data.yotpoId" />
        </KetchWrapper>
      </SimpleAccordion>

      <SimpleAccordion v-if="yotpoEnabled" id="scrollTarget-reviews" header="Reviews">
        <h2 v-if="!$device.isMobile">Reviews</h2>
        <KetchWrapper name="Reviews" class="bg-gray-lighter">
          <YotpoReviews :data="data" />
        </KetchWrapper>
      </SimpleAccordion>

      <SimpleAccordion v-if="yotpoEnabled" id="scrollTarget-qa" header="Q&A">
        <h2 v-if="!$device.isMobile">Q&amp;A</h2>
        <KetchWrapper name="Q&A" class="bg-gray-lighter">
          <YotpoQuestions :data="data" />
        </KetchWrapper>
      </SimpleAccordion>
    </div>
  </div>
</template>
<script setup lang="ts">
const { $device, $sitewideConfig } = useNuxtApp()
const recStore = useRecommendationsStore()
const { isIntegrationEnabled, isRealtruckBrand } = useUtils()
const yotpoEnabled = isIntegrationEnabled('yotpo')

const hasRelatedProducts = computed(() => !!recStore.state.related)

const { hasCustomerPhotos, data } = defineProps<{
  hasCustomerPhotos: boolean
  data: ProductLine
}>()

const gridCols = computed(() => {
  if ($device.value.isMobile) return 1
  if (!$device.value.isDesktop) return 2
  return data.videos?.videos && data.videos.videos.length > 2 ? 4 : 2
})
</script>
